import type { CrudColumnDef } from "@/components/tables/crudColumnDef";
import { sanitizeValuesBeforeSendingToApi } from "@/components/tables/genericCrudTable.utils";
import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";

export interface CreatePayloadContext {
  columns: CrudColumnDef[];
  subdomain: string;
  canEditUserRoles: boolean;
  companySubjectId?: string;
  companyId?: string;
  selectedChildCompanySubjectId?: string; // redux state.parent.subjectId
  globalSubjectValue?: string | number; // redux state.subjectSearch.value
  currentUserSubjectId?: string | number; // redux state.login.subjectId
  searchId?: string;
  additionalSubmitDataForCreate?: Record<string, unknown>;
  entityAdapter?: EntityAdapter;
}

export const buildCreatePayload = (
  values: any,
  ctx: CreatePayloadContext
): any => {
  let result = sanitizeValuesBeforeSendingToApi(values, ctx.columns);

  if (ctx.entityAdapter?.adjustCreatePayload) {
    result = ctx.entityAdapter.adjustCreatePayload(result, values, ctx);
  }

  if (ctx.additionalSubmitDataForCreate) {
    for (const [key, value] of Object.entries(
      ctx.additionalSubmitDataForCreate
    )) {
      result[key] = value;
    }
  }

  if (ctx.entityAdapter?.finishCreatePayload) {
    result = ctx.entityAdapter.finishCreatePayload(result, values, ctx);
  }

  return result;
};
